export default {
  title: "طرق الدفع",
  subtitle: "إدارة طرق وخيارات الدفع",
  
  addNew: "إضافة طريقة دفع جديدة",
  createPaymentMethod: "إنشاء طريقة دفع",
  editPaymentMethod: "تعديل طريقة الدفع",
  deletePaymentMethod: "حذف طريقة الدفع",
  
  fields: {
    name: "اسم الطريقة",
    type: "نوع الدفع",
    description: "الوصف",
    isActive: "نشط",
    processingFee: "رسوم المعالجة",
    currency: "العملة",
    provider: "المزود",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    percent: "النسبة المئوية"
  },
  
  placeholders: {
    name: "أدخل اسم طريقة الدفع",
    type: "اختر نوع الدفع",
    description: "أدخل الوصف",
    processingFee: "أدخل رسوم المعالجة",
    provider: "أدخل اسم المزود",
    percent: "أدخل النسبة المئوية"
  },
  
  messages: {
    createSuccess: "تم إنشاء طريقة الدفع بنجاح",
    createError: "فشل في إنشاء طريقة الدفع",
    updateSuccess: "تم تحديث طريقة الدفع بنجاح",
    updateError: "فشل في تحديث طريقة الدفع",
    deleteSuccess: "تم حذف طريقة الدفع بنجاح",
    deleteError: "فشل في حذف طريقة الدفع",
    deleteConfirm: "هل أنت متأكد من حذف طريقة الدفع هذه؟",
    noPaymentMethods: "لا توجد طرق دفع",
    loadingPaymentMethods: "جاري تحميل طرق الدفع...",
    fetchError: "فشل في جلب طرق الدفع"
  },
  
  validation: {
    nameRequired: "اسم طريقة الدفع مطلوب",
    nameMinLength: "اسم طريقة الدفع يجب أن يكون حرفين على الأقل",
    typeRequired: "نوع الدفع مطلوب",
    processingFeeMin: "رسوم المعالجة يجب أن تكون 0 أو أكثر",
    percentRequired: "النسبة المئوية مطلوبة",
    percentMaxValue: "النسبة المئوية لا يمكن أن تتجاوز 100%",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة"
  },
  
  table: {
    name: "الاسم",
    type: "النوع",
    provider: "المزود",
    processingFee: "الرسوم",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  types: {
    creditCard: "بطاقة ائتمان",
    debitCard: "بطاقة خصم",
    bankTransfer: "تحويل بنكي",
    cash: "نقدي",
    check: "شيك",
    digitalWallet: "محفظة رقمية"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط"
  },
  
  breadcrumbs: {
    paymentMethods: "طرق الدفع",
    create: "إنشاء طريقة دفع",
    edit: "تعديل طريقة الدفع",
    view: "عرض طريقة الدفع"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة"
  }
};
